// userSelectors.js

export const selectDepartment = (state) => state.home.department;
export const selectLoading = (state) => state.home.loading;
export const selectError = (state) => state.home.error;
export const selectLocation = (state) => state.home.location;
export const selectHospital = (state) => state.home.hospital;
export const selectPromotions = (state) => state.home.promotions;


